import React from "react";

import Spinner from "../Spinner";

const Loading = () => {
    return (
        <div className="min-w-screen bg-white-smoke flex min-h-screen items-start justify-center py-12">
            <div>
                <Spinner />
            </div>
        </div>
    );
};

export default Loading;
